var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.7137C9.32589 15.7137 9.17857 15.6535 9.05804 15.5329L2.79018 9.48605C2.72321 9.43248 2.63114 9.34542 2.51395 9.22489C2.39676 9.10435 2.21094 8.88504 1.95647 8.56696C1.70201 8.24888 1.47433 7.92243 1.27344 7.58761C1.07254 7.25279 0.893415 6.84766 0.736049 6.37221C0.578683 5.89676 0.5 5.43471 0.5 4.98605C0.5 3.51283 0.925223 2.36105 1.77567 1.53069C2.62612 0.700335 3.80134 0.285156 5.30134 0.285156C5.71652 0.285156 6.14007 0.357143 6.57199 0.501116C7.00391 0.645089 7.40569 0.839286 7.77734 1.08371C8.149 1.32812 8.46875 1.55748 8.73661 1.77176C9.00446 1.98605 9.25893 2.21373 9.5 2.4548C9.74107 2.21373 9.99554 1.98605 10.2634 1.77176C10.5312 1.55748 10.851 1.32812 11.2227 1.08371C11.5943 0.839286 11.9961 0.645089 12.428 0.501116C12.8599 0.357143 13.2835 0.285156 13.6987 0.285156C15.1987 0.285156 16.3739 0.700335 17.2243 1.53069C18.0748 2.36105 18.5 3.51283 18.5 4.98605C18.5 6.46596 17.7333 7.97266 16.1998 9.50614L9.94196 15.5329C9.82143 15.6535 9.67411 15.7137 9.5 15.7137Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearticon);
export default __webpack_public_path__ + "static/media/hearticon.6e40eee40fffd82b1a3acff864463215.svg";
export { ForwardRef as ReactComponent };